/**
 * @typedef {'regular' | 'confirm' } ModalButtonsVariant
 */

export const MODAL_BUTTONS_VARIANT = {
  CONFIRM: 'confirm',
  REGULAR: 'regular',
}

// Set only on a showing (non-minimized) modal, so corner launchers drop under its mask.
export const MODAL_OPEN_ATTRIBUTE = 'data-modal-open'

/**
 * @typedef {'edit' | 'create' } ModalHeaderVariant
 */

export const MODAL_HEADER_VARIANT = {
  CREATE: 'create',
  EDIT: 'edit',
}

export const MINIMIZED_MODAL_KEY = {
  EMAIL_FORM: 'email-form',
  ENTITY_TAB_EMAILS_MESSAGE: 'entity-tab-emails-message',
  RENTAL_PORTAL_APPLICANT_EMAIL: 'rental-portal-applicant-email',
  RENTAL_PORTAL_APPLICANT_FORM: 'rental-portal-applicant-form',
  RENTAL_PORTAL_LISTING_FORM: 'rental-portal-listing-form',
  REQUEST_FORM: 'request-form',
  REQUEST_PROFILE_EMAIL_THREAD: 'request-profile-email-thread',
  REQUEST_WIZARD_FORM: 'request-wizard-form',
}

// Identifies which subtree the host of a minimizable modal lives in. Used by
// `confirmBeforeAction` to gate only the entries whose host would actually be
// unmounted by the action being attempted (for example, switching the email
// preview item only kills modals opened from the email profile).
export const MINIMIZED_MODAL_SCOPE = {
  EMAIL_PROFILE: 'email-profile',
  RENTAL_PORTAL_LISTING_PROFILE: 'rental-portal-listing-profile',
  REQUEST_PROFILE: 'request-profile',
  REQUEST_PROFILE_EMAIL_THREAD: 'request-profile-email-thread',
  REQUEST_PROFILE_TAB: 'request-profile-tab',
}

// Every scope whose host lives somewhere inside a service-request profile —
// the list a teardown of the whole profile must pass to `confirmBeforeAction`.
export const MINIMIZED_MODAL_REQUEST_PROFILE_SCOPES = [
  MINIMIZED_MODAL_SCOPE.EMAIL_PROFILE,
  MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE,
  MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE_EMAIL_THREAD,
  MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE_TAB,
]
